<template>
  <div :class="classList" :style="styleList" class="c-execution-progress">
    <div
      v-if="textShow"
      class="c-execution-progress__text font:caption opacity:surface-medium"
    >
      <div class="c-execution-progress__text__group">
        <span class="c-execution-progress__text__sub">
          <span>{{ value }}</span>
          <span>&nbsp;{{ translation.per }}&nbsp;</span>
          <span>{{ max }}</span>
        </span>
      </div>
    </div>
    <d-progress
      :value="value"
      :max="max"
      class="c-execution-progress__progress"
    />
  </div>
</template>

<script>
import DProgress from 'dcode/components/DProgress'
import Translation from '../classes/Translation'
import { computed } from 'vue'

export default {
  name: 'CExecutionProgress',
  components: {
    DProgress
  },
  props: {
    value: Number,
    max: Number,

    palette: {
      type: String,
      default: 'tertiary'
    },
    textShow: {
      type: Boolean,
      default: true
    }
  },
  setup (props) {
    /**
     * @type {Object.<string, string>}
     */
    const translation = Translation.getByList([
      'per'
    ])

    return {
      classList: computed(() => {
        return {
          [`palette:${props.palette}`]: props.palette
        }
      }),
      styleList: computed(() => {
        return {
          '--_ep-value': props.value,
          '--_ep-max': props.max
        }
      }),

      translation
    }
  }
}
</script>

<style lang="scss">
.c-execution-progress {
  /* Высота элемента */
  --pr-height: 8px;

  /* Фон не выделенный част */
  --opacity-container-pressed: .04;

  overflow: hidden;

  &__text {
    padding-bottom: 8px;
    overflow: hidden;

    &__group {
      transform: translateX(#{calc(100% / var(--_ep-max) * var(--_ep-value))});
    }

    &__sub {
      transform: translateX(#{calc(100% / var(--_ep-max) * var(--_ep-value) * -1)});
      display: inline-block;
    }
  }

  & &__progress {
    border-radius: var(--radius-pill);
    position: static;
  }
}
</style>
